<prlw-mobile-overlay-card-ui
  label="Управление таблицей"
  [showDoneButton]="true"
  (eventClickX)="eventClose.emit()"
  (eventClickMobileButton)="eventClose.emit()"
>
  <prlw-mobile-list-section-ui
    body
    [items]="items"
    (eventClick)="eventMobileListSectionItemClick.emit($event)"
    (eventUpdateItemsInArray)="eventUpdateItemsInArray.emit($event)"
  >
  </prlw-mobile-list-section-ui>
</prlw-mobile-overlay-card-ui>
